import React, { useState } from 'react';
import * as Yup from 'yup';

import { CForm, CCol } from '@coreui/react-pro';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { SimpleInputGroup } from '../../../../General/Forms';

import { TRAINING_GROUP_FORM } from '../../../../../constants';

const validationSchema = (setValidateOnChange) => {
     setValidateOnChange(true);
     return Yup.object().shape({
          name: Yup.string().trim().required('Required.'),
     });
};

const TrainingGroupFormik = ({ initialValues, handleCreateGroup }) => {
     const [validateOnChange, setValidateOnChange] = useState(false);

     return (
          <Formik
               initialValues={initialValues}
               validationSchema={() => validationSchema(setValidateOnChange)}
               onSubmit={handleCreateGroup}
               validateOnChange={validateOnChange}
               validateOnBlur={false}
          >
               {({ values, errors, handleChange, handleSubmit, isSubmitting }) => {
                    return (
                         <CForm onSubmit={handleSubmit} noValidate className="row g-3" id={TRAINING_GROUP_FORM}>
                              <CCol>
                                   <SimpleInputGroup
                                        id="name"
                                        label="Name"
                                        isRequired
                                        value={values?.name}
                                        error={errors?.name}
                                        handleChange={handleChange}
                                        disabled={isSubmitting}
                                        isValidate={true}
                                   />
                              </CCol>
                         </CForm>
                    );
               }}
          </Formik>
     );
};

TrainingGroupFormik.propTypes = {
     initialValues: PropTypes.shape({
          name: PropTypes.string,
     }),
};

export default TrainingGroupFormik;
